import script from "./PaidView.vue?vue&type=script&setup=true&lang=js"
export * from "./PaidView.vue?vue&type=script&setup=true&lang=js"

import "./PaidView.vue?vue&type=style&index=0&id=11124167&scoped=true&lang=css"

import exportComponent from "C:\\Codeframe\\Dev\\cdn\\pay\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11124167"]])

export default __exports__